import type { ReactNode } from 'react'
import { useUiPresentationStore } from '@store'

const MORE_ICON = (
  <svg
    className='h-5 w-5'
    fill='none'
    stroke='currentColor'
    viewBox='0 0 24 24'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.8}
      d='M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z'
    />
  </svg>
)

/**
 * Adaptación KUBE: solo Módulos + Texturas (+ Más).
 * Sin paso "Opciones" (ArmsCushionsPanel no existe en este producto).
 * Correspondencia: ATEMPORAL mobile-28-07-2026 (`47ee2081`) — ModeBar.
 */
const MODES: {
  id: 'modules' | 'textures' | 'more'
  label: string
  step?: number
  icon?: ReactNode
}[] = [
  { id: 'modules', label: 'Módulos', step: 1 },
  { id: 'textures', label: 'Texturas', step: 2 },
  { id: 'more', label: 'Más', icon: MORE_ICON },
]

export function ModeBar() {
  const activeSheet = useUiPresentationStore((s) => s.activeSheet)
  const toggleSheet = useUiPresentationStore((s) => s.toggleSheet)

  return (
    <nav
      className='fixed bottom-0 left-0 right-0 z-[70] border-t border-[#E8DFC8] bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-sm'
      aria-label='Navegación del configurador'
    >
      <ul className='mx-auto flex h-14 max-w-lg items-stretch justify-around px-1'>
        {MODES.map((mode) => {
          const active = activeSheet === mode.id
          return (
            <li
              key={mode.id}
              className='flex-1'
            >
              <button
                type='button'
                onClick={() => toggleSheet(mode.id)}
                className={`flex h-full w-full flex-col items-center justify-center gap-0.5 text-[11px] font-medium transition-colors ${
                  active ? 'text-colorAtemporal' : 'text-C/Color3/70'
                }`}
                aria-pressed={active}
              >
                {mode.step != null ? (
                  <span
                    className={`flex h-6 w-6 items-center justify-center rounded-full text-sm font-extrabold ${
                      active
                        ? 'border border-[#C8A85A] bg-gradient-to-b from-[#E1C57A] to-[#C8A85A] text-white'
                        : 'border border-[#D7C9A6] bg-[#FAF4E8] text-[#8B6F2E]'
                    }`}
                  >
                    {mode.step}
                  </span>
                ) : (
                  mode.icon
                )}
                <span>{mode.label}</span>
              </button>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
